module.exports = __webpack_public_path__ + "img/default_banner.59d83b25.png";